<template>
    <div class="login-body">
        <div class="login-panel p-fluid">
            <div class="login-panel-content">
                <div class="grid">
                    <div class="p-mb-5">
                        <div class="p-d-flex p-jc-center p-mb-5"><img style="max-width: 20%" src="/assets/logo-highlight-common.svg" alt="yuzaner" /></div>

                        <h3 class="p-d-flex p-jc-center p-mt-2"><span>{{ $store.state.i18n.messageBundle?.password_reset?.title }}</span></h3>
                        
                        <h4>{{ $store.state.i18n.messageBundle?.password_reset?.email_reset_code }}</h4>
                        <div class="p-mt-2">
                            <p>                                
                                <code>{{ $store.state.i18n.messageBundle?.password_reset?.email_reset_code_desc }}</code>
                            </p>
                        </div>
                        <div class="p-my-3">
                            <a class="p-button-link" @click="gotoReqResetCodeByEmail()">&nbsp;<span class="pi pi-check-circle"></span>&nbsp;{{ $store.state.i18n.messageBundle?.password_reset?.email_reset_code_req }}</a>
                        </div>
                        <div class="p-my-2"> 
                            <a class="p-button-link" @click="gotoPasswordResetWithEmail()">&nbsp;<span class="pi pi-pencil"></span>&nbsp;{{ $store.state.i18n.messageBundle?.password_reset?.email_reset_code_proceed }}</a>
                        </div>

                        <hr/>
                        
                        <h4>{{ $store.state.i18n.messageBundle?.password_reset?.sms_reset_code }}</h4>
                        <div class="p-mt-2">
                            <p>                                
                                <code>{{ $store.state.i18n.messageBundle?.password_reset?.sms_reset_code_desc }}</code>
                            </p>
                        </div>
                        <div class="p-my-3">
                            <a class="p-button-link" @click="gotoReqResetCodeByPhone()">&nbsp;<span class="pi pi-check-circle"></span>&nbsp;{{ $store.state.i18n.messageBundle?.password_reset?.sms_reset_code_req }}</a>
                        </div>
                        <div class="p-my-2"> 
                            <a class="p-button-link" @click="gotoPasswordResetWithPhone()">&nbsp;<span class="pi pi-pencil"></span>&nbsp;{{ $store.state.i18n.messageBundle?.password_reset?.sms_reset_code_proceed }}</a>
                        </div>

                        <hr/>
                        
                        <div style="padding-bottom: 50px"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import AuthService from '../service/AuthService';
import UtilService from '../service/UtilService';
export default {
    authService: null,
    utilService: null,
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            email: '',
            submitted: false,
            isProcessing: false,
            isError: false,
            isRequestSuccess: false,
            errorMsg: '',
        };
    },
    created() {
        this.$store.dispatch('createTitle', process.env.VUE_APP_QUOTE);
        this.authService = new AuthService();
        this.utilService = new UtilService();

        let user = this.$loadUserData(this);
        if (user) {
            this.$gotoProfile(this);
        }
    },
    validations() {
        return {
            email: {
                required,
            },
        };
    },
    methods: {        
        gotoReqResetCodeByEmail() {
            this.$router.push({ path: '/request-reset-password-with-email' });
        },
        gotoPasswordResetWithEmail() {
            this.$gotoResetPasswordWithEmail(this);
        },
        gotoReqResetCodeByPhone() {
            this.$router.push({ path: '/request-reset-password-with-phone' });
        },
        gotoPasswordResetWithPhone() {
            this.$gotoResetPasswordWithPhone(this);
        }
    },
};
</script>

<style lang="scss" scoped>


.login-body {
    overflow: hidden;
    position: relative;
    background: url('https://stc-content.ackaya.com/_exp_content/yuzaner/common/images/digital-bg1.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 150vh;
    padding: 0;
    margin: 0;
}

.login-holder {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
a {
    cursor: pointer;
}
a:hover {
    text-decoration: none;
}

.input-group-button {
    margin-top: 0em !important;
    display: block;
    min-width: auto !important;
}

.login-body .login-panel {
    background-color: rgba(255, 255, 255, 0.9);
    opacity: 0.95;
}

@media screen and (max-width: 40em) {
    .login-body {
        height: 180vh;
    }

    .login-body .login-panel {
        background-color: rgba(255, 255, 255, 0.9);
        opacity: 0.95;
        height: 100%;
    }
}
</style>
